export default __webpack_public_path__ + "static/abstractColor-b4263623f4551f12e61abf4daa7fb0ba.svg";